module.exports = __webpack_public_path__ + "img/gal-6.a85569cd.jpg";